import { isEmpty } from 'lodash';
import { dataSchemaToTSDeclaration } from '@tencent/data-schema-core/lib/convertor/typescript';
import { requestCGI } from './requestCGI';
import { getRuntimeConfig } from './collectionAPI';
import { DataSourceBase } from './DataSourceBase';
export class HTTPSource extends DataSourceBase {
    async getTSDeclaration(typePrefix = 'DataSource_') {
        const { cgiInfo } = await getRuntimeConfig({
            projectId: this.projectId,
            collectionId: this.collectionId,
        });
        const tsMap = {};
        Object.entries(cgiInfo).forEach(([methodName, info]) => {
            tsMap[methodName] = {
                query: dataSchemaToTSDeclaration(isEmpty(info.fixedQuerySchema) ? (info.querySchema || {}) : info.fixedQuerySchema, {}),
                body: dataSchemaToTSDeclaration(isEmpty(info.fixedBodySchema) ? (info.bodySchema || {}) : info.fixedBodySchema, {}),
                response: dataSchemaToTSDeclaration(isEmpty(info.fixedResponseSchema) ? (info.responseSchema || {}) : info.fixedResponseSchema, {}),
            };
            // 处理特殊响应类型
            const { responseType } = info;
            if (responseType === 'blob') {
                tsMap[methodName].response = {
                    exportedTypeId: 'Blob',
                    getFullCode: () => '',
                };
            }
            else if (responseType === 'base64') {
                tsMap[methodName].response = {
                    exportedTypeId: 'Base64String',
                    getFullCode: () => 'type Base64String = `data:${string};base64,${string}`;',
                };
            }
            else if (responseType === 'arraybuffer') {
                tsMap[methodName].response = {
                    exportedTypeId: 'ArrayBuffer',
                    getFullCode: () => '',
                };
            }
        });
        const ts = `interface ${typePrefix}${this.collectionId} {
${Object.entries(tsMap).reduce((acc, [key, value]) => `${acc} ${key}: (query: ${value.query.exportedTypeId}, body: ${value.body.exportedTypeId}) => Promise<${value.response.exportedTypeId}>;\n`, '')}}

${Object.values(tsMap).reduce((acc, value) => `${acc}${value.query.getFullCode()}\n${value.body.getFullCode()}\n${value.response.getFullCode()}\n`, '')}`;
        return ts;
    }
    async getMethods() {
        const { cgiInfo } = await this.getCollectionInfo();
        const methods = {};
        Object.keys(cgiInfo).forEach((methodName) => {
            methods[methodName] = async (query, body) => {
                const response = await requestCGI(this.collectionId, methodName, { query, body }, {});
                return response.data;
            };
        });
        return methods;
    }
}
